import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "../../context/API_Client";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import LoadingLogoPage from "../loadingPage/loadingPage";
import { useNavigate } from "react-router";
import "./offerManagement.css";
import OfferManagementContext from "../../context/offerManagement.context";
import NoOrLowCostEmi from "./noOrLowCostEmi/NoOrLowCostEmi";
import { isEmpty } from "../utils/utils";

export default function OfferManagement(operationPermissions) {
  const { allNoOrLowCostOffers, setAllNoOrLowCostOffers, inputSearchData, pageLimit, pageNo, setTotalDataCount, callApi, setCallApi } = useContext(OfferManagementContext);
  const navigate = useNavigate();
  const { getAllOffer } = useAuth();
  const [loading, setLoading] = useState(true);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  let toDate = new Date();
  toDate.setHours(23, 59, 59, 999);
  let fromDate = new Date(toDate);
  fromDate.setMonth(fromDate.getMonth() - 13);
  fromDate.setHours(0, 0, 0, 0);


  useEffect(() => {
    if (!callApi) {
      setLoading(false)
      return setCallApi(true)
    }

    const payload = {
      fromDate: fromDate,
      toDate: toDate,
      limit: 500,
      sort: {
        addedTimestamp: "desc",
      },
      limit: pageLimit,
      offset: (pageNo - 1) * pageLimit
    };
    if (!isEmpty(inputSearchData)) {
      payload.advancedAttributeFilters = inputSearchData;
    }
    getAllOffer(
      payload,
      function (data) {
        setAllNoOrLowCostOffers(data?.points);
        setTotalDataCount(data.totalCount);
        setLoading(false);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
        setLoading(false);
      }
    );
  }, [inputSearchData, pageLimit, pageNo]);

  return (
    <>
      {loading ? (
        <div className="content-wrapper whiteBg">
          <section className="content offerManagementLoadingSection">
            <LoadingLogoPage />
          </section>
        </div>
      ) : isEmpty(allNoOrLowCostOffers) && isEmpty(inputSearchData) ? (
        <div className="content-wrapper whiteBg">
          <section className="content">
            <EmptyState
              image={
                <img
                  src="/assets/sealQuestion.svg"
                  alt="offers"
                  sx={{
                    color: "rgba(201, 201, 204, 1)",
                    height: "120px",
                    width: "120px",
                  }}
                />
              }
              mainText={"Offer Management"}
              subText={"Create new offer and specify the offer details to create a unique offer for your customers"}
              btnText={"Create No or Low Cost EMI"}
              btnPermission={operationPermissions?.addOffer}
              btnFunction={() => navigate("/offerManagement/createEmiOffer")}
            />
          </section >
        </div >
      ) : (
        <NoOrLowCostEmi setLoading={setLoading} />
      )}
    </>
  );
}
